// extracted by mini-css-extract-plugin
export default {"poweredByLogo":"src-signer-app-signer-experience-action-banners-banners-module__poweredByLogo--QCeFz"};